var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-custom-colors"},[_c('div',{staticClass:"uppercase xs-text"},[_vm._v("Create a fully custom colour scheme")]),_c('div',{staticClass:"uppercase xs-text mt-3 xs-content"},[_vm._v("If you would like to create a fully custom colour scheme. Simply click Configure Next and our atelier will work with you to refine the design.")])])
}]

export { render, staticRenderFns }